import { Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserState } from '../states/user.state';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { switchMap } from 'rxjs/operators';
import { Navigate } from '@ngxs/router-plugin';

@Injectable({
  providedIn: 'root'
})
export class LoggedInGuard implements CanActivate {

  constructor(
    private store: Store,
    private router: Router,
    private afAuth: AngularFireAuth
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.afAuth.idTokenResult.pipe(
      switchMap(idToken => {
        const isGhost = this.store.selectSnapshot(UserState.isGhost);
        if (isGhost === '0') {
          return of(true);
        } else {
          this.store.dispatch(new Navigate(['/auth']));
          return of(false);
        }
      })
    );
  }
}
